import { prepareState } from './utils';
import { ConsentStorage } from '../ConsentStorage';
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["ALLOW_ALL"] = "ALLOW_ALL";
    ACTIONS["DISALLOW_ALL"] = "DISALLOW_ALL";
    ACTIONS["PROVIDER_OFF"] = "PROVIDER_OFF";
    ACTIONS["PROVIDER_ON"] = "PROVIDER_ON";
})(ACTIONS || (ACTIONS = {}));
export const reducer = (state, action) => {
    let updatedStorage;
    switch (action.type) {
        case ACTIONS.ALLOW_ALL:
            updatedStorage = ConsentStorage.allowAll();
            break;
        case ACTIONS.DISALLOW_ALL:
            updatedStorage = ConsentStorage.removeAllowAll();
            break;
        case ACTIONS.PROVIDER_ON:
            if (action.provider) {
                updatedStorage = ConsentStorage.setProvider(action.provider.hostName, action.provider.displayName);
            }
            break;
        case ACTIONS.PROVIDER_OFF:
            if (action.provider) {
                updatedStorage = ConsentStorage.removeProvider(action.provider.hostName);
            }
            break;
        default:
    }
    if (updatedStorage) {
        return prepareState(updatedStorage, state);
    }
    return state;
};
//# sourceMappingURL=reducer.js.map